// extracted by mini-css-extract-plugin
export default {"default":"CyjsI","underlined":"urCtU"};